<script>
import error from '../error';
import userMedia from '../userMedia';
import vSelect2 from '../vSelect2';
import richTextEditor from '../richTextEditor';
import datepicker from '../datepicker';

export default {
  name: 'newPaiTargets',
  template: '#new-pai-targets-vue',
  components: {
    error,
    userMedia,
    vSelect2,
    richTextEditor,
    datepicker,
  },
  props: [
    'targets_list_url',
    'actions_list_url',
    'indicators_list_url',
    'guest_deseased_url',
    'getUrlIndex',
    'obiettiviTabellati',
    'azioniTabellate',
    'classeTabellata',
    'indicatoriTabellati',
    'risorseTabellate',
    'allAttributes',
    'canManageTarget',
  ],
  data() {
    return {
      loadedModule: false,
      error: false,
      paiTargets: [],
      index: null,
      newPaiTarget: {},
      attributes_array: ['activities_id', 'indicators_list', 'actions_list', 'resources_list'],
    };
  },
  computed: {
    currentUserId() {
      return window.config.user.id;
    },
  },
  mounted() {
    if (!this.loadedModule) {
      window.AreaSelectForDeseaseAndTarget.init(
        this.targets_list_url,
        this.actions_list_url,
        this.indicators_list_url,
        this.guest_deseased_url,
      );

      this.loadedModule = true;
    }

    $('#modal-new-targets-previous').on('hidden', function () {
      this.newPaiTarget = {};
      Loader.hide();
      $('.modal-footer').removeClass('not-clickable');
    });
    eventBus.$on('reordered_pais_target', (new_order) => {
      $.each(this.paiTargets, (i, p_t) => {
        var el = new_order.records.find((e) => e.id === p_t.id);
        this.$set(p_t, 'priority', el.position);
      });
    });
    eventBus.$on('pai_elements', (elements) => {
      this.paiTargets = elements['pais_targets'].map((e, i) => {
        e['id'] = i;
        return e;
      });
      this.paiTargets = this.paiTargets.sort(this.sortedByPriority);
      window.Sortable.init();
    });
    eventBus.$emit('paiTargetOrTeamMounted');
  },
  methods: {
    sortedByPriority(a, b) {
      return a.priority < b.priority ? -1 : a.priority > b.priority ? 1 : 0;
    },
    showModalForPaiTarget(paiTarget, index) {
      this.newPaiTarget = JSON.parse(JSON.stringify(paiTarget));
      this.newPaiTarget['created_who'] = this.currentUserId;
      this.newPaiTarget['updated_who'] = this.currentUserId;
      this.index = index;
      $('#modal-new-targets-previous').modal('show');
    },
    removePaiTarget(paiTarget) {
      this.error = false;
      this.paiTargets = this.paiTargets.filter((p) => p !== paiTarget);
    },
    savePaiTarget() {
      Loader.show();
      $('.modal-footer').addClass('not-clickable');
      if (this.index != null) {
        // stiamo modificando una riga
        this.paiTargets = this.paiTargets.map((p, i) => {
          if (i === this.index) {
            return JSON.parse(JSON.stringify(this.newPaiTarget));
          } else {
            return p;
          }
        });
      } else {
        this.newPaiTarget['id'] = this.paiTargets.length;
        this.paiTargets.push(JSON.parse(JSON.stringify(this.newPaiTarget)));
      }
      window.Sortable.init();
      $('#modal-new-targets-previous').modal('hide');
    },
  },
};
</script>
